import { Fn } from 'common/types.ts';
import { getPathToIcon } from 'src/common/utils/utilities';

type Props = {
  onClick?: Fn;
  className?: string;
};
const Handle = ({ onClick, className }: Props) => {
  return (
    <img
      role="button"
      tabIndex={0}
      alt="close-handle"
      height={4}
      width={44}
      src={getPathToIcon('handle')}
      onClick={onClick}
      className={'hover-pointer '.concat(className ?? '')}
    />
  );
};

export default Handle;
